import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print';
import BarcodeComponent from 'react-barcode';

const cambiarMMaPx = (number) => {
    if (number === 0) return 0;
    return number * 3.7795280352161

}

export const Barcode = forwardRef(({ productosSeleccionados, datosPagina }, ref) => {
    const [productos, setProductos] = useState([])
    const printRef = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => printRef.current
    });

    useImperativeHandle(
        ref,
        () => ({
            handlePrintButton() {
                handlePrint()
            }
        }),
    )

    useEffect(() => {
        const items = []
        productosSeleccionados.map(item => {
            for (let index = 0; index < datosPagina.copias; index++) {
                items.push(item)
            }
        })
        setProductos(items)
    }, [datosPagina])

    return (
        <div className='barcode-imprimir-container'>
            <div ref={printRef} className='barcode-imprimir-productos-tabulada3' style={{ width: cambiarMMaPx(datosPagina.anchoHoja) }}>
                {
                    productos.map((producto, index) => {
                        const validarBreak = (index % 3) == 0
                        return (<>
                            <div className='barcorde-imprimir-container-item' style={{
                                maxHeight: cambiarMMaPx(datosPagina.altoSticker),
                                minHeight: cambiarMMaPx(datosPagina.altoSticker),
                                maxWidth: cambiarMMaPx(datosPagina.anchoSticker),
                                minWidth: cambiarMMaPx(datosPagina.anchoSticker)
                            }}>
                                <BarcodeItem key={producto.id} item={producto} datosPagina={datosPagina} />
                            </div>
                            {validarBreak && < div className="pagebreak" />}
                        </>)

                    })
                }
            </div>
        </div >
    )
})

const BarcodeItem = ({ item, datosPagina }) => (
    <div className='barcode-imprimir-producto' >

        <span style={{ fontSize: cambiarMMaPx(datosPagina.tamanoProducto) }}>{item.nombre_producto} ({item.id})</span>


        <BarcodeComponent value={item.id} displayValue={false} height={cambiarMMaPx(datosPagina.barcode)} margin={0} />

    </div>
)